var map = {
	"./blog_grid_1.jpg": 28317,
	"./blog_grid_2.jpg": 46069,
	"./blog_grid_3.jpg": 75895,
	"./blog_grid_4.jpg": 69006,
	"./blog_grid_5.jpg": 22358,
	"./blog_grid_6.jpg": 17573,
	"./blog_grid_7.jpg": 99122,
	"./blog_grid_8.jpg": 10622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42373;